import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';
import {ProfileComponent} from './profile.component';
import {IsLoggedIn} from '../../services/auth-guard/auth-guard.service';



@NgModule({
  declarations: [
    ProfileComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path: 'profile', component: ProfileComponent, canActivate: [IsLoggedIn]},
    ])
  ]
})
export class ProfileModule { }
